import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SlidersHorizontal, Heart } from "lucide-react";

export const NO_FILTERS = { genre: "all", key: "all", sort: "newest", favOnly: false };

const FilterSelect = ({ value, onChange, placeholder, items, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="h-9 w-full sm:w-44 rounded-none bg-[#121212] border-white/10 text-sm focus:ring-0 focus:border-[#D90429]">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-[#121212] border-white/10 text-white">
      {items.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testId}-option-${v}`}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const BeatFilters = ({ beats, filters, setFilters, signedIn }) => {
  const genres = [...new Set(beats.map((b) => b.genre).filter(Boolean))].sort();
  const keys = [...new Set(beats.map((b) => b.key).filter(Boolean))].sort();
  const set = (k) => (v) => setFilters({ ...filters, [k]: v });
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-4" data-testid="beat-filters">
      <span className="hidden sm:inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-white/50 mr-2">
        <SlidersHorizontal className="h-4 w-4 text-[#D90429]" /> Find your vibe
      </span>
      <FilterSelect value={filters.genre} onChange={set("genre")} testId="filter-genre"
        items={[["all", "All genres"], ...genres.map((g) => [g, g])]} />
      <FilterSelect value={filters.key} onChange={set("key")} testId="filter-key"
        items={[["all", "All keys"], ...keys.map((k) => [k, k])]} />
      <FilterSelect value={filters.sort} onChange={set("sort")} testId="sort-tempo"
        items={[["newest", "Newest first"], ["bpm-asc", "Tempo: slow → fast"], ["bpm-desc", "Tempo: fast → slow"]]} />
      {signedIn && (
        <button onClick={() => setFilters({ ...filters, favOnly: !filters.favOnly })} data-testid="filter-favourites"
          aria-pressed={filters.favOnly}
          className={`h-9 px-4 inline-flex items-center justify-center gap-2 border text-xs font-bold uppercase tracking-wider transition-colors ${filters.favOnly ? "bg-[#D90429] border-[#D90429] text-white" : "bg-[#121212] border-white/10 text-white/70 hover:border-[#D90429]"}`}>
          <Heart className="h-4 w-4" fill={filters.favOnly ? "currentColor" : "none"} /> Favourites
        </button>
      )}
    </div>
  );
};

export const applyFilters = (beats, { genre, key, sort, favOnly }) => {
  const out = beats.filter((b) => (genre === "all" || b.genre === genre) && (key === "all" || b.key === key) && (!favOnly || b.favorited));
  if (sort === "newest") return out;
  const dir = sort === "bpm-asc" ? 1 : -1;
  return [...out].sort((a, b) => (a.bpm == null) - (b.bpm == null) || dir * ((a.bpm || 0) - (b.bpm || 0)));
};
